@if (show) {
    @if (mode === 'determinate') {
        <mat-progress-bar mode="determinate" [value]="progress"></mat-progress-bar>
    } @else {
        <mat-progress-bar [mode]="mode"></mat-progress-bar>
    }
}
